import React from 'react';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
export const TestimonialsPage = () => {
  return <div className="pt-8" data-id="element-291">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 mb-12" data-id="element-292">
        <h1 className="text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-293">
          Customer Success Stories
        </h1>
        <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto" data-id="element-294">
          See how companies are building high-performing sales teams with
          ApplicantPass.
        </p>
      </div>
      <TestimonialsSection data-id="element-295" />
      <CTASection data-id="element-296" />
    </div>;
};